import {
  AddOutlined,
  DeleteOutline,
  EditOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined,
} from "@material-ui/icons";
import {
  Avatar,
  Box,
  Button,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import AppButton from "../shares/AppButton";
import { DataGrid } from "@mui/x-data-grid";
import { getBackendProfilePictureLink } from "../../../Helpers/utilsHelper";
import { AssociationService } from "../../../service/AssociationService";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import useConfirmation from "../../../hooks/useConfirmation";
import MembreForm from "./MembreForm";
import { frFR } from "@mui/x-data-grid/locales";
import { useNavigate } from "react-router-dom";
import { useQuery } from "../../../hooks/useQuery";
import AssignerMembreAssociationParLot from "../mes_demandes/membre_par_lot/AssignerMembreAssociationParLot";

const ListeMembreAssociation = ({ currentAssociation }) => {
  const [membres, setMembres] = useState([]);
  const [currentIdMembre, setCurrentIdMembre] = useState(null);
  const { Toast, showToast } = useToast();
  const [membreFormOpen, setMembreFormOpen] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [openSelectMembre, setOpenSelectMembre] = useState(false);
  const navigate = useNavigate();
  const { DialogComponent, openConfirmDialog } = useConfirmation();
  const [selectedLotID, setSelectedLotID] = useState(null);
  const query = useQuery();
  const handleFetchMembres = (currentAssociation) => {
    // if (!currentAssociation.uuid) return;
    setDataLoading(true);
    AssociationService.showMembres(currentAssociation.uuid)
      .then((res) => {
        if (res && res.data) {
          setMembres(res.data);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const confirmDeleteMembre = (membre) => {
    AssociationService.deleteMembre(
      membre.id_ext_responsable_association,
      currentAssociation.uuid
    ).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchMembres(currentAssociation);
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleDeleteMembre = (membre) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => confirmDeleteMembre(membre),
      () => {}
    );
  };
  const handleShowMembreDetail = (membre) => {
    navigate(`association-membre?ref=${membre.id_responsable}`);
  };

  const table_colonne = [
    {
      field: "membre_pdp",
      headerName: "",
      minWidth: 80,
      flex: 0.25,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      resizable: false,
      renderCell: (params) => {
        return (
          <Grid>
            <Avatar
              sx={{
                m: 1,
                width: "clamp(20px, 15vw, 40px)",
                height: "clamp(20px, 15vw, 40px)",
                fontSize: "clamp(10px, 8vw, 18px)",
              }}
              alt={String(params.row.membre_nom).toUpperCase() || "Asso"}
              src={getBackendProfilePictureLink(params.row.photo)}
            />
          </Grid>
        );
      },
    },
    {
      field: "membre_nom",
      headerName: "Nom",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "membre_prenoms",
      headerName: "Prenoms",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "role_responsable",
      headerName: "Fonction",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "telephone1",
      headerName: "Telephone ",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "action",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Grid>
            <Button
              title="Afficher le CV du membre"
              color="primary"
              onClick={(e) => handleShowMembreDetail(params.row)}
              variant="contained"
              size="small"
            >
              CV
            </Button>
            <IconButton
              title="Modifier membre"
              color="primary"
              onClick={(e) =>
                handleEditMembre(params.row.id_ext_responsable_association)
              }
            >
              <EditOutlined />
            </IconButton>
            <IconButton
              title="Supprimer membre"
              color="warning"
              onClick={(e) => handleDeleteMembre(params.row)}
            >
              <DeleteOutline />
            </IconButton>
            <Button
              sx={{
                display: window.location.pathname.includes("mes-demandes")
                  ? ""
                  : "none",
              }}
              title="Remplir le formulaire pour membre"
              color="primary"
              variant="contained"
              size="small"
              onClick={(e) => handleDeleteMembre(params.row)}
            >
              {/* <ListAltOutlined /> */}
              Form..
            </Button>
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchMembres(currentAssociation);
  }, [currentAssociation]);

  const handleOpenMembreForm = (membreId) => {
    setMembreFormOpen(true);
    setCurrentIdMembre(membreId);
  };

  const handleAddMembre = () => {
    if (window.location.pathname.includes("mes-demandes")) {
      handleOpenSelectMembre(selectedLotID);
    } else {
      handleOpenMembreForm(null);
    }
  };
  const handleEditMembre = (membreId) => {
    handleOpenMembreForm(membreId);
  };

  const handleCloseMembreForm = () => {
    setMembreFormOpen(false);
    handleFetchMembres(currentAssociation);
  };

  const handleOpenSelectMembre = (id_lot) => {
    setOpenSelectMembre(true);
    setSelectedLotID(id_lot);
  };

  const handleCloseSelectMembre = () => {
    setOpenSelectMembre(false);
  };

  return (
    <>
      <AssignerMembreAssociationParLot
        selectedLotID={selectedLotID}
        open={openSelectMembre}
      />
      <MembreForm
        idMembre={currentIdMembre}
        open={membreFormOpen}
        onFormClose={handleCloseMembreForm}
        association_uuid={currentAssociation.uuid}
      />
      <DialogComponent />
      <Toast />
      <CardHeader
        title="Liste des membres/equipes permanents"
        titleTypographyProps={{ variant: "h5" }}
        avatar={
          <Grid>
            <IconButton onClick={(e) => handleFetchMembres(currentAssociation)}>
              <RefreshOutlined />
            </IconButton>
          </Grid>
        }
        action={
          <Grid>
            <AppButton
              text="Ajouter"
              onClick={handleAddMembre}
              variant="contained"
              icon={<AddOutlined />}
            />
          </Grid>
        }
      />
      {/* <Grid sx={{ overflowX: "auto", width: "100", height: "35vh" }}> */}
        <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
        <DataGrid
          sx={{
            width: {
              xs: "85.5vw",
              sm: "90vw",
              md: "93.5vw",
              lg: "100%",
            },
            height: "100vh",
          }}
          autoHeight
          getRowId={(row) => row.id_ext_responsable_association}
          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
          columns={table_colonne}
          rows={membres}
        />
      {/* </Grid> */}
    </>
  );
};

export default ListeMembreAssociation;
